import React, { useState, useEffect } from 'react';
import ImageGenerator from '../components/image/ImageGenerator';
import api from '../utils/api';

const ImagePage = () => {
  const [images, setImages] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await api.get('/api/images');
        setImages(response.data.map(img => ({
          ...img,
          imageUrl: img.image_url || img.imageUrl
        })));
      } catch (error) {
        console.error('Failed to fetch images:', error);
      }
    };
    fetchImages();
  }, []);

  const handleGenerate = async (prompt) => {
    setIsGenerating(true);

    try {
      const response = await api.post('/api/images/generate', { prompt });

      const newImage = {
        id: response.data.id,
        prompt: response.data.prompt,
        // Use image_url from backend if available, fallback to base64 for backwards compatibility
        imageUrl: response.data.image_url || `data:image/png;base64,${response.data.image_data}`,
        createdAt: response.data.created_at,
        status: 'completed'
      };

      setImages(prev => [newImage, ...prev]);
    } catch (error) {
      console.error('Failed to generate image:', error);
      alert('Failed to generate image. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  const handleReTheme = async (prompt, imageData, style, renderEngine = 'nano-banana') => {
    setIsGenerating(true);

    try {
      const response = await api.post('/api/images/retheme', { 
        prompt, 
        image_data: imageData,
        style,
        render_engine: renderEngine
      });

      console.log('Retheme response received, image_data length:', response.data.image_data?.length);
      
      // Check if we have valid response
      if (!response.data.image_url && !response.data.image_data) {
        throw new Error('No image data received from server');
      }

      const newImage = {
        id: response.data.id,
        prompt: response.data.prompt,
        // Use image_url from backend if available, fallback to base64 for mobile compatibility
        imageUrl: response.data.image_url || `data:image/png;base64,${response.data.image_data}`,
        createdAt: response.data.created_at,
        status: 'completed',
        model: response.data.model_used
      };

      console.log('New image created with URL:', newImage.imageUrl?.substring(0, 50));
      
      setImages(prev => [newImage, ...prev]);
      return newImage;
    } catch (error) {
      console.error('Failed to re-theme image:', error);
      alert('Failed to transform image. Please try again.');
      throw error;
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <ImageGenerator
      images={images}
      onGenerate={handleGenerate}
      onReTheme={handleReTheme}
      isGenerating={isGenerating}
    />
  );
};

export default ImagePage;
